/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WelcomePingResponse interface.
 */
export function instanceOfWelcomePingResponse(value) {
    if (!('ok' in value) || value['ok'] === undefined)
        return false;
    if (!('stitched' in value) || value['stitched'] === undefined)
        return false;
    if (!('visitToken' in value) || value['visitToken'] === undefined)
        return false;
    return true;
}
export function WelcomePingResponseFromJSON(json) {
    return WelcomePingResponseFromJSONTyped(json, false);
}
export function WelcomePingResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ok': json['ok'],
        'stitched': json['stitched'],
        'visitToken': json['visit_token'],
    };
}
export function WelcomePingResponseToJSON(json) {
    return WelcomePingResponseToJSONTyped(json, false);
}
export function WelcomePingResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ok': value['ok'],
        'stitched': value['stitched'],
        'visit_token': value['visitToken'],
    };
}
